import { useEffect, useState } from "react";
import { isI18nReady, waitForI18n } from "src/locales/i18n";

export function useI18nReady() {
	const [ready, setReady] = useState(false);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		let mounted = true;

		const checkI18nReady = async () => {
			try {
				// Wait for i18n to be initialized
				await waitForI18n();

				// Double-check that i18n is actually ready
				if (isI18nReady() && mounted) {
					setReady(true);
				} else if (mounted) {
					// If not ready yet, poll until ready
					const pollInterval = setInterval(() => {
						if (isI18nReady() && mounted) {
							setReady(true);
							clearInterval(pollInterval);
						}
					}, 50);

					// Clear interval after 10 seconds to prevent infinite polling
					setTimeout(() => {
						if (mounted) {
							console.error("i18n initialization timeout after 10 seconds");
							clearInterval(pollInterval);
							setError(new Error("i18n initialization timeout"));
						}
					}, 10000);
				}
			} catch (err) {
				console.error("Error during i18n initialization:", err);
				if (mounted) {
					setError(err instanceof Error ? err : new Error("Unknown i18n error"));
				}
			}
		};

		checkI18nReady();

		return () => {
			mounted = false;
		};
	}, []);

	return { ready, error };
}
